module.exports = "/_next/static/media/0d85952632c7602ecea7b517b29f3fb7.png";